// Opt-in zip codes (migration 054). Reported only in aggregate. Entering a zip IS the opt-in, so the
// notice must sit beside every field a member types one into — and the zip is
// only ever saved through set_my_zip_code, the one path that records consent.
// A direct profile update would store the zip without it.

// Purposes (2026-09-30): local trainings, events and perks as they launch,
// plus aggregate counts of DSPs by area. Changing what the zip
// is used for means changing this text — it is what members agreed to.
export const ZIP_NOTICE =
  "By adding your zip, you'll see trainings, events and perks in your area as we " +
  'launch them. We may also include it in anonymous, combined totals about DSPs. ' +
  'You’ll never be personally identified, we never sell your data, and you can opt ' +
  'out anytime.';

/** Digits only, at most 5 — the DB accepts exactly 5 or nothing. */
export const cleanZip = (value) => value.replace(/[^0-9]/g, '').slice(0, 5);

export const isValidZip = (value) => /^[0-9]{5}$/.test(value);
